// After a deploy the old build's split JS files are gone. A window still on the
// old build that moves to a screen it has not loaded yet fails to import it
// ("Importing a module script failed" on a home screen app). Reload once to
// get the new build. If the new build fails the same way, do not loop: no
// second reload within a short while.

const KEY = "trameria:stale-chunk-reload";
const WINDOW_MS = 10_000;

/** Reloads unless it just did; true when it reloads. */
export function reloadForStaleChunk(
  reload: () => void = () => location.reload(),
  now = Date.now(),
): boolean {
  try {
    const last = Number(sessionStorage.getItem(KEY) ?? "0");
    if (now - last < WINDOW_MS) return false;
    sessionStorage.setItem(KEY, String(now));
  } catch {
    // Cannot remember it: no reload, to never loop.
    return false;
  }
  reload();
  return true;
}

/** Vite reports a split JS or CSS file it could not load. */
export function installStaleChunkReload(): void {
  window.addEventListener("vite:preloadError", (event) => {
    // Reloading: the caller does not need to see the error.
    if (reloadForStaleChunk()) event.preventDefault();
  });
}
